import errors from './errors/index.js';
const throwError = (message) => {
    const name = getErrorName(message);
    const error = createError(name);
    throw new error(message);
};
const createError = (name) => {
    return class extends Error {
        constructor(message) {
            super(message);
            this.name = name;
        }
    };
};
const getErrorName = (message) => {
    if (Object.keys(errors.authorization).includes(message)) {
        return 'AuthorizationError';
    }
    if (Object.keys(errors.conflict).includes(message)) {
        return 'ConflictError';
    }
    if (Object.keys(errors.forbidden).includes(message)) {
        return 'ForbiddenError';
    }
    if (Object.keys(errors.notFound).includes(message)) {
        return 'NotFoundError';
    }
    if (Object.keys(errors.unprocessableEntity).includes(message)) {
        return 'UnprocessableEntityError';
    }
    return 'Error';
};
export default throwError;
//# sourceMappingURL=throwError.js.map